import { render, staticRenderFns } from "./TabsNotification.vue?vue&type=template&id=8227b8ce&scoped=true&"
import script from "./TabsNotification.vue?vue&type=script&lang=js&"
export * from "./TabsNotification.vue?vue&type=script&lang=js&"
import style0 from "./TabsNotification.vue?vue&type=style&index=0&id=8227b8ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8227b8ce",
  null
  
)

export default component.exports